import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { InvoiceKsefStatus } from '../enums';
import { SelectItem } from '@web/shared/ui';

@Injectable({
  providedIn: 'root',
})
export class InvoiceKsefStatusProviderService {
  private readonly entries = new Map<InvoiceKsefStatus, string>([
    [InvoiceKsefStatus.Pending, 'Oczekująca na wysyłkę'],
    [InvoiceKsefStatus.Sent, 'Wysłana do KSeF'],
    [InvoiceKsefStatus.Success, 'Przetworzona w KSeF'],
    [InvoiceKsefStatus.Error, 'Błąd KSeF'],
  ]);

  public labelFor(status: InvoiceKsefStatus): Observable<string> {
    const result = this.entries.get(status);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" is not found.`,
      );
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<InvoiceKsefStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) => new SelectItem<InvoiceKsefStatus>(label, status),
      ),
    );
  }
}
